import { useEffect } from "react";
import Cal, { getCalApi } from "@calcom/embed-react";
import {
  CalendarDays,
  CheckCircle2,
  Clock3,
  MapPin,
  ShieldCheck,
  Sparkles,
} from "lucide-react";

const CAL_LINK = "martin-somogyvari-ulifp6/szemelyi-edzes";

export default function Booking() {
  useEffect(() => {
    const initializeCal = async () => {
      const cal = await getCalApi({
        namespace: "szemelyi-edzes",
      });

      cal("ui", {
        theme: "dark",
        hideEventTypeDetails: false,
        layout: "month_view",
        styles: {
          branding: {
            brandColor: "#d7b56d",
          },
        },
      });
    };

    initializeCal().catch((error) => {
      console.error("A Cal.com nem töltődött be:", error);
    });
  }, []);

  return (
    <section id="idopontfoglalas" className="booking-section">
      <div className="booking-background-grid" />

      <div className="container booking-shell">
        <div className="booking-content">
          <div className="booking-kicker">
            <Sparkles size={15} />
            Online időpontfoglalás
          </div>

          <h2 className="booking-title">
            Foglald le a
            <span> következő edzésed.</span>
          </h2>

          <p className="booking-intro">
            Válaszd ki a számodra megfelelő szabad időpontot. A foglalás
            után e-mailes visszaigazolást kapsz, az alkalom pedig
            automatikusan bekerül a naptárba.
          </p>

          <div className="booking-details">
            <div className="booking-detail">
              <div className="booking-detail-icon">
                <Clock3 size={20} />
              </div>

              <div>
                <span>Időtartam</span>
                <strong>60 perces személyi edzés</strong>
              </div>
            </div>

            <div className="booking-detail">
              <div className="booking-detail-icon">
                <MapPin size={20} />
              </div>

              <div>
                <span>Helyszín</span>
                <strong>Cutler Gym, Székesfehérvár</strong>
              </div>
            </div>

            <div className="booking-detail">
              <div className="booking-detail-icon">
                <CalendarDays size={20} />
              </div>

              <div>
                <span>Foglalás</span>
                <strong>Legfeljebb 30 nappal előre</strong>
              </div>
            </div>
          </div>

          <div className="booking-times">
            <div>
              <span>Hétfő–péntek</span>
              <strong>17:00–18:00</strong>
              <strong>18:00–19:00</strong>
            </div>

            <div>
              <span>Szombat–vasárnap</span>
              <strong>07:00–08:00</strong>
              <strong>08:00–09:00</strong>
              <strong>09:00–10:00</strong>
              <strong>10:00–11:00</strong>
              <strong>11:00–12:00</strong>
            </div>
          </div>

          <div className="booking-policy">
            <div className="booking-policy-heading">
              <ShieldCheck size={21} />
              <strong>Foglalási feltételek</strong>
            </div>

            <ul>
              <li>
                <CheckCircle2 size={16} />
                Kérlek, érkezz körülbelül 10 perccel korábban.
              </li>

              <li>
                <CheckCircle2 size={16} />
                Hozz magaddal váltócipőt, törölközőt és folyadékot.
              </li>

              <li>
                <CheckCircle2 size={16} />
                Lemondás vagy módosítás legalább 24 órával korábban
                lehetséges.
              </li>
            </ul>
          </div>
        </div>

        <div className="booking-calendar-column">
          <div className="booking-calendar-frame">
            <div className="booking-frame-header">
              <div>
                <span className="booking-frame-dot" />
                <span className="booking-frame-dot" />
                <span className="booking-frame-dot" />
              </div>

              <span>Martin Coaching időpontfoglalás</span>
            </div>

            <div className="booking-cal-wrapper">
              <Cal
                namespace="szemelyi-edzes"
                calLink={CAL_LINK}
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "760px",
                  overflow: "scroll",
                }}
                config={{
                  layout: "month_view",
                  useSlotsViewOnSmallScreen: "true",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}